import { OrderBy } from '../components/Hooks/useList.types';

const buildOrder = (order: OrderBy): Record<string, string> => {
  const formatedOrder: Record<string, string> = {};

  if (!order) {
    return formatedOrder;
  }

  for (const key in order) {
    formatedOrder[`order[${key}]`] = order[key];
  }

  return formatedOrder;
};

export const paginate = {
  limit: (value: any) => ({ limit: value }),
  skip: (value: any) => ({ skip: value }),
  sort: (value: any) => buildOrder(value),
  order: (value: any) => buildOrder(value),
};
